module.exports = {"data":{"allMarketTapProductCategory":{"edges":[{"node":{"id":"6","slug":"planning","name":"Planning"}},{"node":{"id":"7","slug":"social-media","name":"Social Media"}},{"node":{"id":"8","slug":"content-writing","name":"Content Writing"}},{"node":{"id":"9","slug":"photo-video","name":"Photo / Video"}},{"node":{"id":"10","slug":"graphic-design","name":"Graphic Design"}},{"node":{"id":"11","slug":"packages","name":"Packages"}}]}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 172
// module chunks = 60335399758886 114276838955818